import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IIceCatReportCommitedProductCountRequest } from '../models/models'

export class GetIceCatReportCommitedProductCountApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/icecat/GetIceCatReportCommitedProductCount',
      requesterInfo,
    })
  }

  public async getIceCatReportCommitedProductCount(request: IIceCatReportCommitedProductCountRequest): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
